import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { lcApiBase, lcHttpError, lcStationId } from './logiciel-caisse-api.helper';
import { LogicielCaisseAuthService } from './logiciel-caisse-auth.service';

interface PutResponse {
  success: boolean;
  error?: string;
}

@Injectable({ providedIn: 'root' })
export class LogicielCaisseReasortPrioriteService {
  constructor(
    private readonly http: HttpClient,
    private readonly authService: LogicielCaisseAuthService
  ) {}

  putOrder(orderedEntrepotIds: string[]): Observable<void> {
    let stationId: number;
    try {
      stationId = lcStationId(this.authService);
    } catch (e) {
      return throwError(() => (e instanceof Error ? e : new Error(String(e))));
    }
    const url = `${lcApiBase(this.authService)}/api/entrepots/reasort-priorite/station/${stationId}`;
    const body = {
      ordered_entrepot_ids: orderedEntrepotIds.map((id) => Number(id)),
    };
    return this.http.put<PutResponse>(url, body).pipe(
      map((res) => {
        if (!res?.success) {
          throw new Error(res?.error || 'Enregistrement impossible');
        }
      }),
      catchError((err: HttpErrorResponse) =>
        throwError(() => lcHttpError(err, "Erreur lors de l'enregistrement de l'ordre."))
      )
    );
  }
}
